import { ReactNode } from 'react'

import { TabPanel, TabPanelProps } from '.'

export type TabPanelDefaultProps = Omit<TabPanelProps, 'children'> & {
  children: ReactNode
}

export const TabPanelDefault = ({ children, value }: TabPanelDefaultProps) => (
  <TabPanel value={value}>
    {({ isActive }) =>
      isActive ? (
        <TabPanel.Styled.Container
          aria-labelledby={`${value}-trigger`}
          id={value}
          role="tabpanel"
          tabIndex={0}
        >
          {children}
        </TabPanel.Styled.Container>
      ) : null
    }
  </TabPanel>
)
